import React from 'react';
import { useTranslation } from 'react-i18next';
import SEO from '../components/SEO';
import './Information.css';

const Information = () => {
  const { t } = useTranslation();

  return (
    <div className="information-container">
      <SEO title={t('information.title') || 'Tietoja'} description="Yhteystiedot ja yritystiedot – Mikkelin Sukkulat Oy, Pussikuskit." path="/information" />
      <div className="container">
        <h1>{t('information.title') || 'Tietoja'}</h1>
        <div className="information-content">
          <div className="information-section">
            <p><strong>Yritys:</strong> Mikkelin Sukkulat Oy</p>
            <p><strong>Y-tunnus:</strong> 3446752-2</p>
            <p><strong>Yrityksen osoite (ei käyntiä)</strong><br />Leiritulenkatu 2, 50190 Mikkeli</p>
            <p><strong>Asiakaspalvelu:</strong>{' '}
              <a href="mailto:asiakaspalvelu@pussikuskit.fi">asiakaspalvelu@pussikuskit.fi</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Information;
